<template>
  <div class="table-responsive">
    <table class="table invoice-table">
      <thead>
        <tr>
          <th scope="col">Descrição</th>
          <th scope="col" class="text-left text-md-right">Subtotal</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td>
            {{ item.descdesconto }}
          </td>
          <td class="text-left text-md-right">
            {{ item.vlrtotaldesconto | currency }}  
          </td>
        </tr>
        <tr>
          <td> {{ "SUBTOTAL:" }}
          </td>
          <td class="text-left text-md-right"><b>{{ totalSum | currency }}</b></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "List",
  props: {
    items: Array,
  },
  computed: {
    totalSum() {
      return this.items.reduce((sum, item) => sum + item.vlrtotaldesconto, 0);
    }
  },
  filters: {
    currency(valor) {
      if (isNaN(valor)) {
        return "-";
      } else {
        var formatter = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
        return formatter.format(valor);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";

th {
  color: #6c757d;
  font-weight: 300;
  font-size: 14px;
  text-transform: uppercase;
  border: none;
}

td {
  color: #212529;
  font-weight: 300;
  font-size: 16px;
  text-transform: uppercase;
  border-color: #e9ecef;

  .info {
    font-weight: 400;
    font-size: 12px;
  }
}

.pdf-content {
  th {
    font-size: 10px;
  }

  td {
    font-size: 12px;
  }
}

.invoice-table {
  width: 100%;
  border-collapse: collapse;
}

.invoice-table th, .invoice-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.invoice-table th {
  background-color: #f7f7f7;
}
</style>
